import { AuditByStatusesFilter } from './audit-by-statuses-filter';

export class AuditWorkflowSearchFilter extends AuditByStatusesFilter {
  AuditStatusId: number;
  constructor(auditByStatusesFilter: AuditByStatusesFilter, statusId: number) {
    super(auditByStatusesFilter.AuditSpecialistId);
    this.AuditStatusId = statusId;
  }
}
